var _Confirmation, _div, _div2;
import PropTypes from 'prop-types';
import React from 'react';
import { Form, StandardPhoneInput, Input, validationRules } from 'reaxl-forms';
import { Alert, Button, DisclaimerText } from 'reaxl';
import Confirmation from '../Confirmation/index.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const renderError = errorMessage => /*#__PURE__*/_jsx(Alert, {
  bsStyle: "danger",
  children: errorMessage
});
const validationMessages = {
  enterName: 'Please enter your user name.',
  hasInvalidChars: 'contains invalid characters.',
  isProfane: 'Please remove all profanity from your message.'
};

/**
 *  This component allows you to send text messages to others
 *
 */
const ShareText = /*#__PURE__*/React.memo(_ref => {
  let {
    disclaimer = '',
    listingId,
    message,
    onSubmit = () => {},
    serverError,
    showConfirmation,
    userName = '',
    ...rest
  } = _ref;
  validationRules();
  const handleMessageSubmit = formData => {
    const requestData = {
      listingId,
      message,
      ...formData
    };
    onSubmit(requestData);
  };
  if (showConfirmation) {
    return _Confirmation || (_Confirmation = /*#__PURE__*/_jsx(Confirmation, {
      text: "Your Text has been sent.",
      confirmationMessage: ""
    }));
  }
  delete rest.onTabClick;
  return /*#__PURE__*/_jsxs("div", {
    ...rest,
    children: [/*#__PURE__*/_jsxs(Form, {
      onValidSubmit: handleMessageSubmit,
      children: [serverError && renderError(serverError), /*#__PURE__*/_jsxs("div", {
        className: "row",
        children: [/*#__PURE__*/_jsx("div", {
          className: "col-xs-12 col-sm-6",
          children: /*#__PURE__*/_jsx(Input, {
            label: "Your Name",
            name: "userName",
            required: true,
            value: userName,
            validations: {
              isValidName: true,
              isNotProfane: true
            },
            validationErrors: {
              isDefaultRequiredValue: validationMessages.enterName,
              isValidName: `Your Name ${validationMessages.hasInvalidChars}`,
              isNotProfane: validationMessages.isProfane
            }
          })
        }), _div || (_div = /*#__PURE__*/_jsx("div", {
          className: "col-xs-12 col-sm-6",
          children: /*#__PURE__*/_jsx(StandardPhoneInput, {
            label: "Recipient's Mobile Number",
            name: "phoneNumber",
            required: true
          })
        }))]
      }), /*#__PURE__*/_jsx(Input, {
        type: "hidden",
        name: "textPot",
        id: "textPot",
        validations: {
          minLength: 0
        }
      }), _div2 || (_div2 = /*#__PURE__*/_jsx("div", {
        className: "display-flex justify-content-center",
        children: /*#__PURE__*/_jsx(Button, {
          type: "submit",
          bsStyle: "primary",
          className: "col-xs-12 col-sm-4",
          formNoValidate: true,
          children: "Send Text"
        })
      }))]
    }), /*#__PURE__*/_jsx(DisclaimerText, {
      className: "margin-top-5",
      children: disclaimer
    })]
  });
});
export default ShareText;